import React from "react";
import Wrapper from "../../helpers/Wrapper";
import ThreeFactCon from "./ThreeFactCon";
import img1 from "../../assets/images/cms1_e1.png";
import img2 from "../../assets/images/cms2_e1.png";
import img3 from "../../assets/images/cms4_e1.png";

function ThreeFact() {
  const data = [
    {
      title: "Secure Payment",
      description: "Your transactions are safe and encrypted.",
      img: img2,
    },
    {
      title: "Fast Delivery",
      description: "Quick and reliable shipping to your door.",
      img: img1,
    },
    {
      title: "Online Support",
      description: "24/7 assistance for all your needs.",
      img: img3,
    },
  ];

  return (
    <div className="w-full relative">
      <Wrapper>
        <hr className="mb-12" />
        {/* Containers */}
        <div className="flex flex-col md:flex-row items-start gap-y-10">
          {data.map((service, i) => (
            <div className="w-full" key={i}>
              <ThreeFactCon
                title={service.title}
                description={service.description}
                img={service.img}
              />
            </div>
          ))}
        </div>
      </Wrapper>
    </div>
  );
}

export default ThreeFact;
